<app-modal #modal class="diary-config-modal">
  <div class="modal-header">
    <h2 class="modal-title">E-Diary Settings</h2>
    <button type="button" class="close" (click)="modal.hide()" aria-label="Close">
      <span aria-hidden="true"><i class="far fa-times"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">

      <div class="form-group">
        <label class="timezone-label">Patient Timezone <sup *ngIf="isRequired('timezone')">*</sup></label>
        <app-timezone-select #timezoneSelect (optionChanged)="onTimezoneChanged($event)" [parentForm]="form" controlName="timezone"></app-timezone-select>
      </div>

      <section>
        <div class="reminder-toggles">
          <div class="checkbox-wrap">
            <label class="checkbox" [ngClass]="{'checked': form.get('visitRemindersEnabled').value}">
              <input type="checkbox" id="visitRemindersEnabled" formControlName="visitRemindersEnabled" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="visitRemindersEnabled">Enable Visit Reminders</label>
          </div>

          <div class="app-email" [class.visibility-hidden]="form.get('visitRemindersEnabled').value !== true">
            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('visitRemindersAppEnabled').value}">
                <input type="checkbox" id="visitRemindersAppEnabled" formControlName="visitRemindersAppEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="visitRemindersAppEnabled">App</label>
            </div>

            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('visitRemindersEmailEnabled').value}">
                <input type="checkbox" id="visitRemindersEmailEnabled" formControlName="visitRemindersEmailEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="visitRemindersEmailEnabled">Email</label>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="reminder-toggles">
          <div class="checkbox-wrap">
            <label class="checkbox" [ngClass]="{'checked': form.get('urineRemindersEnabled').value}">
              <input type="checkbox" id="urineRemindersEnabled" formControlName="urineRemindersEnabled" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="urineRemindersEnabled">Enable Urine Reminders</label>
          </div>

          <div class="app-email" [class.visibility-hidden]="form.get('urineRemindersEnabled').value !== true">
            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('urineRemindersAppEnabled').value}">
                <input type="checkbox" id="urineRemindersAppEnabled" formControlName="urineRemindersAppEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="urineRemindersAppEnabled">App</label>
            </div>

            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('urineRemindersEmailEnabled').value}">
                <input type="checkbox" id="urineRemindersEmailEnabled" formControlName="urineRemindersEmailEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="urineRemindersEmailEnabled">Email</label>
            </div>
          </div>
        </div>


        <div class="section-inner" [ngClass]="{ 'visibility-hidden': form.get('urineRemindersEnabled').value !== true }">
          <div class="field-group">
            <div class="field-group-inner">
              <label>Urine Reminder Time <sup *ngIf="isRequired('urineReminderTime')">*</sup></label>
              <div class="input-wrap">
                <app-input-timepicker formControlName="urineReminderTime"></app-input-timepicker>
              </div>
            </div>
            <span class="helper-text" *ngIf="shouldShowUtcTime('urineReminderTime')">{{ form.get('urineReminderTimeUtc').value }} UTC</span>
          </div>
        </div>
      </section>

      <section>
        <div class="reminder-toggles">
          <div class="checkbox-wrap">
            <label class="checkbox" [ngClass]="{'checked': form.get('dailyDoseRemindersEnabled').value}">
              <input type="checkbox" id="dailyDoseRemindersEnabled" formControlName="dailyDoseRemindersEnabled"
                     value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="dailyDoseRemindersEnabled">Enable Daily Dose Reminders</label>
          </div>

          <div class="app-email" [class.visibility-hidden]="form.get('dailyDoseRemindersEnabled').value !== true">
            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('dailyDoseRemindersAppEnabled').value}">
                <input type="checkbox" id="dailyDoseRemindersAppEnabled" formControlName="dailyDoseRemindersAppEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="dailyDoseRemindersAppEnabled">App</label>
            </div>

            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('dailyDoseRemindersEmailEnabled').value}">
                <input type="checkbox" id="dailyDoseRemindersEmailEnabled" formControlName="dailyDoseRemindersEmailEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="dailyDoseRemindersEmailEnabled">Email</label>
            </div>
          </div>
        </div>
      </section>

      <div class="two-column-inputs">
        <div class="field-group one-third">
          <div class="field-group-inner">
            <label>Daily Dose First Date <sup *ngIf="isRequired('startDate')">*</sup></label>
            <div class="input-wrap">
              <app-datepickerv2-input [parentForm]="form" controlName="startDate"></app-datepickerv2-input>
            </div>
          </div>
        </div>

        <div class="field-group one-third">
          <div class="field-group-inner">
            <label>Daily Dose Last Date <sup *ngIf="isRequired('endDate')">*</sup></label>
            <div class="input-wrap">
              <app-datepickerv2-input [parentForm]="form" controlName="endDate"></app-datepickerv2-input>
            </div>
          </div>
        </div>

        <div class="field-group one-third">
          <div class="field-group-inner">
            <label>Dosage Time<sup *ngIf="isRequired('endDate')">*</sup></label>
            <div class="input-wrap type-time">
              <app-input-timepicker formControlName="dailyDoseReminderTime" *ngIf="!editingDisabled"></app-input-timepicker>
              <div class="fake-field disabled" *ngIf="editingDisabled">{{ form.get('dailyDoseReminderTime').value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="two-column-inputs">
        <div class="field-group">
          <div class="field-group-inner">
            <label>Dose (amount of pills) <sup *ngIf="isRequired('dosage')">*</sup></label>
            <div class="input-wrap">
              <div class="fake-field disabled" *ngIf="editingDisabled">{{ form.get('dosage').value }}</div>
              <input type="number" formControlName="dosage" *ngIf="!editingDisabled">
            </div>
          </div>
        </div>

        <div class="field-group">
          <div class="field-group-inner">
            <label>Dose (text) <sup *ngIf="isRequired('dosageText')">*</sup></label>
            <div class="input-wrap">
              <div class="fake-field disabled" *ngIf="editingDisabled">{{ form.get('dosageText').value }}</div>
              <input type="text" formControlName="dosageText" *ngIf="!editingDisabled">
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="onFormSubmit()" [disabled]="form.invalid || form.get('isBusy').value" class="btn btn-primary">
      <span *ngIf="form.get('isBusy').value">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </span>
      <span *ngIf="!form.get('isBusy').value">Update Settings</span>
    </button>
  </div>
</app-modal>
